import { useSyncExternalStore } from "react";

// Whether MizuIQ's (the AI assistant's) window is open. App renders the one
// window (ChatbotWidget) over every page past sign-in, from this; a page with
// a button of its own for it - the New Dashboard's robot, in its map corner -
// reads and sets it here too, so the window stays as it is from page to page.
let open = false;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function setAssistantOpen(next) {
  const value = typeof next === "function" ? next(open) : next;
  if (value === open) return;
  open = value;
  listeners.forEach((listener) => listener());
}

export const useAssistantOpen = () => useSyncExternalStore(subscribe, () => open);

// What an answer's button asks the New Dashboard to show - the answer's
// meters on its map ({ kind: "locate", meterIds, alertType, label, source })
// or its Alert Center, on Digital Twin ({ kind: "tab", tab }) - kept until
// the dashboard takes it, as it may first have to be opened. The newest
// replaces any not yet taken; one left too long is dropped (REQUEST_TTL).
export const REQUEST_TTL = 60000;
let dashboardRequest = null;
let requests = 0;
const requestListeners = new Set();

const subscribeRequests = (listener) => {
  requestListeners.add(listener);
  return () => requestListeners.delete(listener);
};

export function requestDashboard(request) {
  requests += 1;
  dashboardRequest = { ...request, id: requests, at: Date.now() };
  requestListeners.forEach((listener) => listener());
}

export function takeDashboardRequest(id) {
  if (dashboardRequest?.id !== id) return;
  dashboardRequest = null;
  requestListeners.forEach((listener) => listener());
}

export const useDashboardRequest = () => useSyncExternalStore(subscribeRequests, () => dashboardRequest);
